"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformZonedTimeToUTC = void 0;
const zonedTimeToUtcOrDefault_1 = require("../helpers/zonedTimeToUtcOrDefault");
function transformZonedTimeToUTC(time, timeZone) {
    const zoned = (0, zonedTimeToUtcOrDefault_1.zonedTimeToUtcOrDefault)(new Date(time), timeZone);
    return zoned;
}
exports.transformZonedTimeToUTC = transformZonedTimeToUTC;
//# sourceMappingURL=transformZonedTimeToUTC.js.map